// src/components/Nav.jsx
import React, { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X, Instagram } from "lucide-react";
import collections from "../../../config/collections";
import site from "../../../config/site";
import useIsMobile from "../../../hooks/useIsMobile";

const links = [
  { to: "/", label: "work", end: true },
  { to: "/about", label: "about" },
  { to: "/contact", label: "contact" },
  { to: "/terms", label: "terms" },
];

function NavLinks({ onNavigate }) {
  return (
    <>
      <ul className="nav-list">
        {links.map((l) => (
          <li key={l.to}>
            <NavLink
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `nav-link${isActive ? " active" : ""}`
              }
              onClick={onNavigate}
            >
              {l.label}
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="nav-section">Collections</div>
      <ul className="nav-sub">
        {collections.map((c) => (
          <li key={c.slug}>
            <NavLink
              to={`/${c.slug}`}
              className={({ isActive }) =>
                `nav-link${isActive ? " active" : ""}`
              }
              onClick={onNavigate}
            >
              {c.title}
            </NavLink>
          </li>
        ))}
      </ul>
    </>
  );
}

export default function Nav() {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close the mobile overlay on route change and lock scroll while open
  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  // Desktop: persistent sticky sidebar
  if (!isMobile) {
    return (
      <aside className="sidebar">
        <Link to="/" className="brand">
          photoLevs.
        </Link>
        <NavLinks />
        <a
          className="ig-btn"
          href={site.instagram}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Instagram size={15} /> Follow
        </a>
      </aside>
    );
  }

  // Mobile: topbar + full‑screen overlay
  return (
    <>
      <header className="topbar">
        <Link to="/" className="brand">
          photoLevs.
        </Link>
        <button aria-label="Open menu" onClick={() => setOpen(true)}>
          <Menu size={24} />
        </button>
      </header>

      {open && (
        <nav className="mobile-menu" aria-label="Site">
          <div className="menu-head">
            <Link to="/" className="brand" onClick={() => setOpen(false)}>
              photoLevs.
            </Link>
            <button aria-label="Close menu" onClick={() => setOpen(false)}>
              <X size={24} />
            </button>
          </div>
          <NavLinks onNavigate={() => setOpen(false)} />
          <a
            className="ig-btn"
            href={site.instagram}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram size={16} /> Follow on Instagram
          </a>
        </nav>
      )}
    </>
  );
}